
































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class CampaignEntryCompleteDialog extends Vue {
  @Prop({ required: true })
  readonly value!: boolean;

  get wrapperDialog() {
    return this.value;
  }

  set wrapperDialog(flag: boolean) {
    this.$emit('input', flag);
  }
}
